module.exports = __webpack_public_path__ + "static/media/horizon.8ba601b6.png";